/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOpenItem.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/open-item";

export class AutogenModelOpenItem<RowType extends ModelRow> extends Endpoint<RowType, RowOpenItemFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOpenItem extends ModelRow<RowOpenItemFields> {
	constructor(values?: Partial<RowOpenItemFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOpenItemFields {
	adjustments: number;
	amount: number;
	amount_billed: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_paid: number;
	amount_r: number;
	ar_reason_code_id: string;
	bill_date: Date;
	"billing_history.agent": string;
	"billing_history.autorate_status": string;
	"billing_history.bill_date": Date;
	"billing_history.bill_of_lading": string;
	"billing_history.bill_type": string;
	"billing_history.billing_empty_distance": number;
	"billing_history.billing_empty_distance_um": string;
	"billing_history.billing_loaded_distance": number;
	"billing_history.billing_loaded_distance_um": string;
	"billing_history.billing_user_id": string;
	"billing_history.blnum": string;
	"billing_history.booking_number": string;
	"billing_history.broker": string;
	"billing_history.canceled": string;
	"billing_history.commodity": string;
	"billing_history.commodity_descr": string;
	"billing_history.company_id": string;
	"billing_history.consignee_ref_no": string;
	"billing_history.container": string;
	"billing_history.correction_ind": string;
	"billing_history.customer_id": string;
	"billing_history.delivery_date": Date;
	"billing_history.dist_include_split": string;
	"billing_history.distance": number;
	"billing_history.distance_um": string;
	"billing_history.driver_id": string;
	"billing_history.edi_transfered": string;
	"billing_history.entered_user_id": string;
	"billing_history.excisetax_total": number;
	"billing_history.excisetax_total_c": string;
	"billing_history.excisetax_total_d": Date;
	"billing_history.excisetax_total_n": number;
	"billing_history.excisetax_total_r": number;
	"billing_history.external_invoiceno": string;
	"billing_history.factoring_exp_date": Date;
	"billing_history.factoring_id": string;
	"billing_history.fixed_charge_label": string;
	"billing_history.fixed_charge_seg_alloc_code": string;
	"billing_history.gp_exported": Date;
	"billing_history.ic_company_from": string;
	"billing_history.ic_movement_from": string;
	"billing_history.ic_order_from": string;
	"billing_history.id": string;
	"billing_history.invoice_no": number;
	"billing_history.invoice_no_string": string;
	"billing_history.invoice_recv_date": Date;
	"billing_history.invoiced_flag": string;
	"billing_history.is_dedicated_bill": string;
	"billing_history.is_fixed": string;
	"billing_history.is_intercompany": string;
	"billing_history.is_split_bill": string;
	"billing_history.is_summary_bill": string;
	"billing_history.last_auto_collect": Date;
	"billing_history.last_auto_collect_type": string;
	"billing_history.linehaul_chg": number;
	"billing_history.linehaul_chg_c": string;
	"billing_history.linehaul_chg_d": Date;
	"billing_history.linehaul_chg_n": number;
	"billing_history.linehaul_chg_r": number;
	"billing_history.lock_miles": string;
	"billing_history.master_order_id": string;
	"billing_history.minimum_weight": number;
	"billing_history.minimum_weight_um": string;
	"billing_history.order_id": string;
	"billing_history.order_type_id": string;
	"billing_history.other_charge": number;
	"billing_history.other_charge_c": string;
	"billing_history.other_charge_d": Date;
	"billing_history.other_charge_n": number;
	"billing_history.other_charge_r": number;
	"billing_history.pay_gross": number;
	"billing_history.pay_gross_c": string;
	"billing_history.pay_gross_d": Date;
	"billing_history.pay_gross_n": number;
	"billing_history.pay_gross_r": number;
	"billing_history.payment_method": string;
	"billing_history.pieces": number;
	"billing_history.port": string;
	"billing_history.post_key": string;
	"billing_history.post_key_openitem": string;
	"billing_history.post_module": string;
	"billing_history.printed": string;
	"billing_history.purchase_order_no": string;
	"billing_history.rate": number;
	"billing_history.rate_id": number;
	"billing_history.rate_type": string;
	"billing_history.rate_unit_desc": string;
	"billing_history.rating_method": string;
	"billing_history.rating_type": string;
	"billing_history.rating_units": number;
	"billing_history.ready_to_process": string;
	"billing_history.rebilled": string;
	"billing_history.revenue_id": string;
	"billing_history.round_trip_flag": string;
	"billing_history.ship_date": Date;
	"billing_history.shipment_id": string;
	"billing_history.total_charges": number;
	"billing_history.total_charges_c": string;
	"billing_history.total_charges_d": Date;
	"billing_history.total_charges_n": number;
	"billing_history.total_charges_r": number;
	"billing_history.totalcharge_and_excisetax": number;
	"billing_history.totalcharge_and_excisetax_c": string;
	"billing_history.totalcharge_and_excisetax_d": Date;
	"billing_history.totalcharge_and_excisetax_n": number;
	"billing_history.totalcharge_and_excisetax_r": number;
	"billing_history.tractor_id": string;
	"billing_history.trailer2_id": string;
	"billing_history.trailer_id": string;
	"billing_history.transfer_date": Date;
	"billing_history.vessel": string;
	"billing_history.weight": number;
	"billing_history.weight_um": string;
	company_from: string;
	company_id: string;
	"customer.activity_count": number;
	"customer.activity_start_date": Date;
	"customer.add_empty_distance_occ": string;
	"customer.add_finance_charge": string;
	"customer.address1": string;
	"customer.address2": string;
	"customer.allow_inc_in_frt": string;
	"customer.auto_rate": string;
	"customer.auto_tax": string;
	"customer.available_template": number;
	"customer.average_bill": number;
	"customer.average_bill_c": string;
	"customer.average_bill_d": Date;
	"customer.average_bill_n": number;
	"customer.average_bill_r": number;
	"customer.average_pay_days": number;
	"customer.balance": number;
	"customer.balance_c": string;
	"customer.balance_d": Date;
	"customer.balance_n": number;
	"customer.balance_r": number;
	"customer.benchmark_ctg_uid": number;
	"customer.benchmark_tar_uid": number;
	"customer.bill_due_days": number;
	"customer.bill_format_flag": string;
	"customer.bill_template": number;
	"customer.bill_transfer_when": string;
	"customer.billed_loads": number;
	"customer.bl_logo": string;
	"customer.bl_logo_name": string;
	"customer.blanket_buy_tariff_id": string;
	"customer.blanket_sell_tariff_id": string;
	"customer.bridge_id": string;
	"customer.brokerage_filter": string;
	"customer.business_hours": string;
	"customer.business_number": string;
	"customer.buy_tariff_id": string;
	"customer.carrier_scorecard_exported": string;
	"customer.category": string;
	"customer.cert_of_ins_date": Date;
	"customer.charge_detention": string;
	"customer.chassis_chargeby": string;
	"customer.chassis_freedays": number;
	"customer.chassis_rate": number;
	"customer.chassis_rate_c": string;
	"customer.chassis_rate_d": Date;
	"customer.chassis_rate_n": number;
	"customer.chassis_rate_r": number;
	"customer.city": string;
	"customer.city_id": number;
	"customer.coll_thresh_pd1": number;
	"customer.coll_thresh_pd1_c": string;
	"customer.coll_thresh_pd1_d": Date;
	"customer.coll_thresh_pd1_n": number;
	"customer.coll_thresh_pd1_r": number;
	"customer.coll_thresh_pd2": number;
	"customer.coll_thresh_pd2_c": string;
	"customer.coll_thresh_pd2_d": Date;
	"customer.coll_thresh_pd2_n": number;
	"customer.coll_thresh_pd2_r": number;
	"customer.coll_thresh_pd3": number;
	"customer.coll_thresh_pd3_c": string;
	"customer.coll_thresh_pd3_d": Date;
	"customer.coll_thresh_pd3_n": number;
	"customer.coll_thresh_pd3_r": number;
	"customer.coll_thresh_pd4": number;
	"customer.coll_thresh_pd4_c": string;
	"customer.coll_thresh_pd4_d": Date;
	"customer.coll_thresh_pd4_n": number;
	"customer.coll_thresh_pd4_r": number;
	"customer.collections_id": string;
	"customer.collections_ok": string;
	"customer.company_id": string;
	"customer.confidence_level": number;
	"customer.container_chargeby": string;
	"customer.container_freedays": number;
	"customer.container_rate": number;
	"customer.container_rate_c": string;
	"customer.container_rate_d": Date;
	"customer.container_rate_n": number;
	"customer.container_rate_r": number;
	"customer.contract_cbc": string;
	"customer.contract_ccc": string;
	"customer.contract_gbc": string;
	"customer.contract_gcc": string;
	"customer.contract_sbc": string;
	"customer.contract_scc": string;
	"customer.controlling_carrier_code": string;
	"customer.conversion_date": Date;
	"customer.cost_ctg_uid": number;
	"customer.cost_tar_uid": number;
	"customer.covered_template": number;
	"customer.cp_logo": string;
	"customer.cp_logo_name": string;
	"customer.credit_application": string;
	"customer.credit_check_date": Date;
	"customer.credit_limit": number;
	"customer.credit_limit_c": string;
	"customer.credit_limit_d": Date;
	"customer.credit_limit_n": number;
	"customer.credit_limit_r": number;
	"customer.credit_status": string;
	"customer.credit_warning_pct": number;
	"customer.ctg_uid": number;
	"customer.currency_type": string;
	"customer.cust_requestor_load_id": string;
	"customer.cust_stmt_template": number;
	"customer.d_and_b_code": string;
	"customer.d_and_b_date": Date;
	"customer.d_and_b_number": string;
	"customer.days_between_calls": number;
	"customer.deadhead_target": number;
	"customer.ded_last_fixed_cost_billdt": Date;
	"customer.dedicated_cycle": string;
	"customer.dedicated_revenue_code_id": string;
	"customer.dedicated_seg_alloc_code": string;
	"customer.dedicated_start_day": string;
	"customer.dedicated_template": number;
	"customer.def_rate_confirm_temp": number;
	"customer.delivered_template": number;
	"customer.departure_date_at": string;
	"customer.disable_automatic_tracking": string;
	"customer.display_eta": string;
	"customer.display_ysplit_stops": string;
	"customer.distance_method": string;
	"customer.distance_profile": string;
	"customer.distance_source": string;
	"customer.distance_type": string;
	"customer.dot_number": string;
	"customer.driver_load": string;
	"customer.empty_distance_charge_id": string;
	"customer.empty_distance_rate": number;
	"customer.enable_notifications": string;
	"customer.enforce_dep_dates": string;
	"customer.entered_date": Date;
	"customer.excise_taxable": string;
	"customer.expected_close": Date;
	"customer.extend_rates": string;
	"customer.factor_percent": number;
	"customer.factor_receivables": string;
	"customer.factoring_id": string;
	"customer.fak_profile_id": string;
	"customer.fourkites_customer_id": string;
	"customer.fuel_amount": number;
	"customer.fuel_base_price": number;
	"customer.fuel_credit": string;
	"customer.fuel_method": string;
	"customer.fuel_percent": number;
	"customer.fuel_price_region": string;
	"customer.fuel_surcharge_id": string;
	"customer.fuel_surchg_enddt": Date;
	"customer.fuel_surchg_strtdt": Date;
	"customer.fuel_variance": number;
	"customer.global_detention": string;
	"customer.google_place_id": string;
	"customer.gp_exclude": string;
	"customer.gp_exported": Date;
	"customer.gp_imported": Date;
	"customer.grace_period": number;
	"customer.high_balance": number;
	"customer.high_balance_c": string;
	"customer.high_balance_d": Date;
	"customer.high_balance_n": number;
	"customer.high_balance_r": number;
	"customer.ic_company_id": string;
	"customer.id": string;
	"customer.include_by_date": string;
	"customer.include_empty_distance": string;
	"customer.include_fuel_surcharge": string;
	"customer.include_split_point": string;
	"customer.integration_type": string;
	"customer.invoice_processing_id": string;
	"customer.is_active": string;
	"customer.is_consignee": string;
	"customer.is_distribution_center": string;
	"customer.is_drop_yard": string;
	"customer.is_geocoded": string;
	"customer.is_intercompany": string;
	"customer.is_pallets_required": string;
	"customer.is_shipper": string;
	"customer.is_trailer_pool_required": string;
	"customer.jaguar_id": number;
	"customer.last_bill_date": Date;
	"customer.last_fin_charge_dt": Date;
	"customer.last_pay_date": Date;
	"customer.last_ship_date": Date;
	"customer.latitude": number;
	"customer.location_id": string;
	"customer.longitude": number;
	"customer.macropoint_requestor_id": string;
	"customer.main_phone": string;
	"customer.manual_exchange": string;
	"customer.mark_plan_id": string;
	"customer.max_pay_percent": number;
	"customer.misc_bill_template": number;
	"customer.monthly_order_goal": number;
	"customer.motor_carrier_id": string;
	"customer.name": string;
	"customer.next_call_date": Date;
	"customer.next_rec_call": Date;
	"customer.nxt_action_code_id": string;
	"customer.nxt_action_date": Date;
	"customer.operations_user": string;
	"customer.order_count": number;
	"customer.order_detail_at": string;
	"customer.order_start_date": Date;
	"customer.override_max_city_radius": number;
	"customer.p44_profile_id": string;
	"customer.paid_loads": number;
	"customer.pay_days_date": Date;
	"customer.pay_days_orders": number;
	"customer.payee_id": string;
	"customer.pd0_alert": number;
	"customer.pd1_np_auto": string;
	"customer.pd1_sp_auto": string;
	"customer.pd1_sp_thresh": number;
	"customer.pd1_sp_thresh_c": string;
	"customer.pd1_sp_thresh_d": Date;
	"customer.pd1_sp_thresh_n": number;
	"customer.pd1_sp_thresh_r": number;
	"customer.pd2_np_auto": string;
	"customer.pd2_sp_auto": string;
	"customer.pd2_sp_thresh": number;
	"customer.pd2_sp_thresh_c": string;
	"customer.pd2_sp_thresh_d": Date;
	"customer.pd2_sp_thresh_n": number;
	"customer.pd2_sp_thresh_r": number;
	"customer.pd3_np_auto": string;
	"customer.pd3_sp_auto": string;
	"customer.pd3_sp_thresh": number;
	"customer.pd3_sp_thresh_c": string;
	"customer.pd3_sp_thresh_d": Date;
	"customer.pd3_sp_thresh_n": number;
	"customer.pd3_sp_thresh_r": number;
	"customer.pd4_np_auto": string;
	"customer.pd4_sp_auto": string;
	"customer.pd4_sp_thresh": number;
	"customer.pd4_sp_thresh_c": string;
	"customer.pd4_sp_thresh_d": Date;
	"customer.pd4_sp_thresh_n": number;
	"customer.pd4_sp_thresh_r": number;
	"customer.plc_uid": number;
	"customer.post_summary_dtl": string;
	"customer.potential": number;
	"customer.potential_c": string;
	"customer.potential_d": Date;
	"customer.potential_n": number;
	"customer.potential_r": number;
	"customer.prev_code": string;
	"customer.primary_agency": string;
	"customer.primary_commodity_id": string;
	"customer.primary_contact": string;
	"customer.primary_sort": string;
	"customer.primary_trailer_type": string;
	"customer.print_containers": string;
	"customer.progress_template": number;
	"customer.prospect_type_id": string;
	"customer.quebec_number": string;
	"customer.quote_days_to_expire": number;
	"customer.rate_override_nmfc_code": string;
	"customer.reassign_profile_id": string;
	"customer.rec_call_days": number;
	"customer.remarks": string;
	"customer.require_tracking": string;
	"customer.required_vendor": string;
	"customer.revenue": number;
	"customer.revenue_c": string;
	"customer.revenue_d": Date;
	"customer.revenue_n": number;
	"customer.revenue_r": number;
	"customer.revenue_start_date": Date;
	"customer.routing_guide_profile_id": string;
	"customer.sales_manager_id": string;
	"customer.sales_status_id": string;
	"customer.salesperson_id": string;
	"customer.search_city": string;
	"customer.search_state_id": string;
	"customer.search_zip_code": string;
	"customer.secondary_sort": string;
	"customer.sell_tariff_id": string;
	"customer.service_fail_cons": string;
	"customer.service_fail_drop": string;
	"customer.service_fail_pick": string;
	"customer.service_fail_ship": string;
	"customer.service_failures": string;
	"customer.service_failures_review": string;
	"customer.shipment_ident_type": string;
	"customer.sic_code": string;
	"customer.smc3_profile_id": string;
	"customer.start_date": Date;
	"customer.state_id": string;
	"customer.summary_billing": string;
	"customer.summary_template": number;
	"customer.tar_uid": number;
	"customer.target_profit": number;
	"customer.tenfour_customer_id": string;
	"customer.toll_oc_exempt": string;
	"customer.tracking_hours_prior": number;
	"customer.trimble_place_id": string;
	"customer.type_of": string;
	"customer.use_local_mile": string;
	"customer.vm_part_update": string;
	"customer.waterfall_auto_route_guides": string;
	"customer.waterfall_lead_time": number;
	"customer.waterfall_notify_email": string;
	"customer.waterfall_process": string;
	"customer.website_url": string;
	"customer.wf_auto_renbill": string;
	"customer.wf_autobill": string;
	"customer.wf_bwop": string;
	"customer.wf_queue": number;
	"customer.zip_code": string;
	"customer.zone_id": string;
	customer_id: string;
	deposit_number: string;
	"edi_billing.agent": string;
	"edi_billing.alt_partner_id": string;
	"edi_billing.autorate_status": string;
	"edi_billing.batch": number;
	"edi_billing.bill_date": Date;
	"edi_billing.bill_tid": number;
	"edi_billing.bill_type": string;
	"edi_billing.billing_empty_distance": number;
	"edi_billing.billing_empty_distance_um": string;
	"edi_billing.billing_id": string;
	"edi_billing.billing_loaded_distance": number;
	"edi_billing.billing_loaded_distance_um": string;
	"edi_billing.billing_user_id": string;
	"edi_billing.blnum": string;
	"edi_billing.booking_number": string;
	"edi_billing.broker": string;
	"edi_billing.carrier_id": string;
	"edi_billing.carrier_tractor": string;
	"edi_billing.carrier_trailer": string;
	"edi_billing.cc_pro_nbr": string;
	"edi_billing.commodity": string;
	"edi_billing.commodity_descr": string;
	"edi_billing.company_id": string;
	"edi_billing.consignee_ref_no": string;
	"edi_billing.consignee_stop_id": string;
	"edi_billing.container": string;
	"edi_billing.correction_ind": string;
	"edi_billing.create_date": Date;
	"edi_billing.currency": string;
	"edi_billing.currency_iso_id": string;
	"edi_billing.currency_type_id": string;
	"edi_billing.customer_ediloc": string;
	"edi_billing.customer_id": string;
	"edi_billing.delivery_date": Date;
	"edi_billing.direction": string;
	"edi_billing.dist_include_split": string;
	"edi_billing.distance": number;
	"edi_billing.distance_um": string;
	"edi_billing.driver_id": string;
	"edi_billing.edi_commodity_id": string;
	"edi_billing.edi_equip_type_id": string;
	"edi_billing.edi_error": number;
	"edi_billing.edi_transfered": string;
	"edi_billing.entered_user_id": string;
	"edi_billing.equipment_type_id": string;
	"edi_billing.error_text": string;
	"edi_billing.excisetax_total": number;
	"edi_billing.excisetax_total_c": string;
	"edi_billing.excisetax_total_d": Date;
	"edi_billing.excisetax_total_n": number;
	"edi_billing.excisetax_total_r": number;
	"edi_billing.external_invoiceno": string;
	"edi_billing.factoring_exp_date": Date;
	"edi_billing.factoring_id": string;
	"edi_billing.fixed_charge_label": string;
	"edi_billing.fixed_charge_seg_alloc_code": string;
	"edi_billing.freight_class": string;
	"edi_billing.frt_grp_pro_nbr": string;
	"edi_billing.func_ack_batch": number;
	"edi_billing.func_ack_id": string;
	"edi_billing.func_ack_rec": string;
	"edi_billing.func_ack_rec_date": Date;
	"edi_billing.func_ack_status": string;
	"edi_billing.gs06_group_cntlno": string;
	"edi_billing.gs_date_time": Date;
	"edi_billing.handling_code1": string;
	"edi_billing.handling_code2": string;
	"edi_billing.ic_company_from": string;
	"edi_billing.ic_movement_from": string;
	"edi_billing.ic_order_from": string;
	"edi_billing.id": string;
	"edi_billing.intercompany": string;
	"edi_billing.invoice_no": number;
	"edi_billing.invoice_no_string": string;
	"edi_billing.invoice_recv_date": Date;
	"edi_billing.invoiced_flag": string;
	"edi_billing.is_balance_due": string;
	"edi_billing.is_dedicated_bill": string;
	"edi_billing.is_fixed": string;
	"edi_billing.is_intercompany": string;
	"edi_billing.is_rebill": string;
	"edi_billing.is_split_bill": string;
	"edi_billing.linehaul_chg": number;
	"edi_billing.linehaul_chg_c": string;
	"edi_billing.linehaul_chg_d": Date;
	"edi_billing.linehaul_chg_n": number;
	"edi_billing.linehaul_chg_r": number;
	"edi_billing.lock_miles": string;
	"edi_billing.master_order_id": string;
	"edi_billing.minimum_weight": number;
	"edi_billing.minimum_weight_um": string;
	"edi_billing.modified_date": Date;
	"edi_billing.modified_user_id": string;
	"edi_billing.movement_id": string;
	"edi_billing.order_id": string;
	"edi_billing.order_type_id": string;
	"edi_billing.other_charge": number;
	"edi_billing.other_charge_c": string;
	"edi_billing.other_charge_d": Date;
	"edi_billing.other_charge_n": number;
	"edi_billing.other_charge_r": number;
	"edi_billing.partner_id": string;
	"edi_billing.pay_gross": number;
	"edi_billing.pay_gross_c": string;
	"edi_billing.pay_gross_d": Date;
	"edi_billing.pay_gross_n": number;
	"edi_billing.pay_gross_r": number;
	"edi_billing.payment_method": string;
	"edi_billing.pieces": number;
	"edi_billing.pieces_qual": string;
	"edi_billing.port": string;
	"edi_billing.post_key": string;
	"edi_billing.post_module": string;
	"edi_billing.printed": string;
	"edi_billing.pro_nbr": string;
	"edi_billing.purchase_order_no": string;
	"edi_billing.rate": number;
	"edi_billing.rate_id": number;
	"edi_billing.rate_type": string;
	"edi_billing.rate_unit_desc": string;
	"edi_billing.rating_method": string;
	"edi_billing.rating_type": string;
	"edi_billing.rating_units": number;
	"edi_billing.ready_to_process": string;
	"edi_billing.ready_to_send": string;
	"edi_billing.rebilled": string;
	"edi_billing.reference_id": string;
	"edi_billing.revenue_id": string;
	"edi_billing.round_trip_flag": string;
	"edi_billing.route_code": string;
	"edi_billing.route_qual": string;
	"edi_billing.scac": string;
	"edi_billing.service_code": string;
	"edi_billing.ship_date": Date;
	"edi_billing.ship_match_descr": string;
	"edi_billing.ship_match_type": string;
	"edi_billing.shipment_id": string;
	"edi_billing.shipper_stop_id": string;
	"edi_billing.splc": string;
	"edi_billing.st02_trxset_cntlno": string;
	"edi_billing.status": string;
	"edi_billing.total_charges": number;
	"edi_billing.total_charges_c": string;
	"edi_billing.total_charges_d": Date;
	"edi_billing.total_charges_n": number;
	"edi_billing.total_charges_r": number;
	"edi_billing.totalcharge_and_excisetax": number;
	"edi_billing.totalcharge_and_excisetax_c": string;
	"edi_billing.totalcharge_and_excisetax_d": Date;
	"edi_billing.totalcharge_and_excisetax_n": number;
	"edi_billing.totalcharge_and_excisetax_r": number;
	"edi_billing.tractor_id": string;
	"edi_billing.trailer2_id": string;
	"edi_billing.trailer_id": string;
	"edi_billing.trans_count": number;
	"edi_billing.transfer_date": Date;
	"edi_billing.transport_method": string;
	"edi_billing.version": string;
	"edi_billing.vessel": string;
	"edi_billing.void_credit_immediately": string;
	"edi_billing.weight": number;
	"edi_billing.weight_qual": string;
	"edi_billing.weight_um": string;
	gl_date: Date;
	id: string;
	invoice_id: string;
	invoice_no: number;
	invoice_no_string: string;
	is_intercompany: string;
	is_split_bill: string;
	order_id: string;
	original_gl_date: Date;
	original_gl_rate: number;
	outstanding_balance: number;
	post_key: string;
	post_module: string;
	record_type: string;
	reference_number: string;
	remaining_credit_balance: number;
	remaining_credit_balance_c: string;
	remaining_credit_balance_d: Date;
	remaining_credit_balance_n: number;
	remaining_credit_balance_r: number;
	remark: string;
	ship_date: Date;
	source: string;
	order_id_input: string;
}

